import {OEObjectModelValueTypes} from '../../elements/object-model-value-edit/oe-object-model-value-edit-model';

export const OEArrowChangeFlags = {
    none:                   0,
    style:                  1,
    transform:              2,
    all:                    3
};

export const OEArrowDataFlags = {
    none:                   0,
    tipStyle:               1,
    endStyle:               2,
    width:                  4,
    lenght:                 8,
    color:                  16,
    smooth:                 32,
    transform:              64,
    style:                  63,
    all:                    127
};

export const OEArrowModels = {

    style: {
        width: {type: OEObjectModelValueTypes.float, allowUndefined: false, min: 0.0, step: 0.001},
        length: {type: OEObjectModelValueTypes.float, allowUndefined: false, min: 0.0, step: 0.001}
    },

    transformation: {
        pos: {type: OEObjectModelValueTypes.vec3, allowUndefined: false, step: 0.001, label: 'position'},
        angles: {type: OEObjectModelValueTypes.vec3, allowUndefined: false, step: 0.001, label: 'rotation'}
    }

};

export const OEArrowExtControllerBtnIds = {
    copyStyle:              'copyStyle',
    pasteStyle:             'pasteStyle',
    copyTransformation:     'copyTransformation',
    pasteTransformation:    'pasteTransformation'
};

export const OEArrowDataSlots = {
    style:                  0,
    transformation:         1
};